import * as Types from '../constants/Types';

const initialState = {
    isFetching: false,
    allData: {
        transactions: [],
        accounts: [],
        transactionImbalances: []
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.CASH_FLOW_GET_TRANSACTION_ACTION:
            return { 
                ...state, 
                allData: { 
                    ...state.allData,
                    transactions: [] 
                }
            };
        case Types.CASH_FLOW_GET_TRANSACTION_SUCCESS:
            return {
                ...state,
                allData: {
                    ...state.allData,
                    transactions: [...state.allData.transactions, ...action.transactions.result]
                }
            }
        case Types.CASH_FLOW_GET_ACCOUNT_ACTION:
            return { 
                ...state, 
                allData: { 
                    ...state.allData,
                    accounts: [] 
                }
            };
        case Types.CASH_FLOW_GET_ACCOUNT_SUCCESS:
            return {
                ...state,
                allData: {
                    ...state.allData,
                    accounts: [...state.allData.accounts, ...action.accounts.result]
                }
            }
        case Types.CASH_FLOW_GET_TRANSACTION_IMBALANCE_ACTION:
            return { 
                ...state, 
                allData: { 
                    ...state.allData,
                    transactionImbalances: [] 
                }
            };
        case Types.CASH_FLOW_GET_TRANSACTION_IMBALANCE_SUCCESS:
            return {
                ...state,
                allData: {
                    ...state.allData,
                    transactionImbalances: [...state.allData.transactionImbalances, ...action.transactionImbalances.result]
                }
            }
        case Types.RECEIPTS_PAYSLIP_ACTION: 
            return {
                ...state,
                isFetching: true
            }
        case Types.RECEIPTS_PAYSLIP_SUCCESS: 
            return {
                ...state,
                isFetching: false
            }
        case Types.RECEIPTS_PAYSLIP_FAIL: 
            return {
                ...state,
                isFetching: false
            }

        default: 
            return state
    }
}
